import { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import './finalDrawing.css'
import constant from '../../constant'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'
import List from '../../components/FinalDrawing/IndexList/index'
import Filter from '../../components/FinalDrawing/IndexList/filter'
import { v3_drawings_count } from '../../actions/v3/inspection'
import { replacePageState } from '../../utils';
const Index = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)
    const [keyword, setKeyword] = useState('');
    const [groupBy, setGroupBy] = useState('none');

    useEffect(() => {
        v3_drawings_count(currentPage, limit, keyword, groupBy).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.finalDrawingIndex.url, {
                    page: currentPage
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit])

    useEffect(() => {
        setCurrentPage(1)
        v3_drawings_count(1, limit, keyword, groupBy).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.finalDrawingIndex.url, {
                    page: currentPage
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [keyword, groupBy])



    return (
        <Layout title='Final Drawing' nonCardVersion={true}>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            

                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="appraisal-report-table-responsive">
                                        <Filter
                                            keyword={keyword}
                                            setKeyword={setKeyword}
                                            groupBy={groupBy}
                                            setGroupBy={setGroupBy}

                                        />
                                        {data && <List
                                            data={data}
                                            limit={limit}
                                            handlePageChange={(newPage) => setCurrentPage(newPage)}
                                        />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Layout>
    )
}

export default Index